import axios from 'axios'
import Vue from 'vue'

const instanct = axios.create({
	baseURL: 'https://culture.aqitai.com',
	timeout: 90000,
	headers: {
		'Content-Type': 'application/json'
	}
})

instanct.interceptors.request.use((req) => {
	req.headers.Authorization = 'Bearer ' + ((localStorage.token) ? (localStorage.token) : '')
	if(req.method=='get'){
		if(req.params){
			req.params.apiterminal = 'Aqt_20230517ApiWeb'
			req.params.lang = localStorage.getItem('lang')
			req.params.terminal = 2
		}else {
			let keyVal ={
				apiterminal:'Aqt_20230517ApiWeb',
				lang:localStorage.getItem('lang'),
				terminal:2,
			}
			Vue.prototype.$set(req,'params',keyVal)
		}

	}else if(req.method=='post'){
		if(req.data){
			req.data.apiterminal = 'Aqt_20230517ApiWeb'
			req.data.lang = localStorage.getItem('lang')
			req.data.terminal = 2
		}else {
			let keyVal ={
				apiterminal:'Aqt_20230517ApiWeb',
				lang:localStorage.getItem('lang'),
				terminal:2,
			}
			Vue.prototype.$set(req,'data',keyVal)
		}
	}

	return req
})

instanct.interceptors.response.use((res) => {

	let mainData = Object.assign({}, res.data)
	if (res.config.method == 'get') {
		let resdata = Object.assign({}, mainData.data)
		if (resdata.current_page) {
			delete resdata.data
		}
		if (mainData.code === 200) {
			return {
				data: resdata.current_page ? mainData.data.data : mainData.data,
				info: {
					'code': mainData.code,
					'message': mainData.message
				},
				pages: resdata.current_page ? resdata : null
			}
		} else {
			handleErr(mainData)
			return Promise.reject({
				'code': mainData.code,
				'message': mainData.message
			})
		}
	} else {
		if (mainData.code === 200) {
			return mainData
		} else {
			handleErr(mainData)
			return Promise.reject({
				'code': mainData.code,
				'message': mainData.message
			})
		}
	}
}, err => {
	if (err.response.status === 401) {
		localStorage.clear()
		// sessionStorage.clear()
		Vm.$store.state.layout.tabList = '[]'
		Vm.$router.push({path:'/login',query:{lib_type:sessionStorage.getItem('gcm')}})
		document.title = ''
	} else {
		if (!err.response) {
			handleErr({
				code: '请求无响应！',
				message: err.config.url
			})
			return false
		}
	}
	return Promise.reject(err)
})

function handleErr(data) {
	if (data.code == 403) {
		Vm.$Notice.error({
			title: '登录超时',
			desc: '请重新登录'
		})
		setTimeout(() => {
			localStorage.clear()
			document.title = ''
			Vm.$router.push({path:'/login',query:{lib_type:sessionStorage.getItem('gcm')}})
		}, 1000)
		return false
	}
	else if(data.code == 300){
		Vm.$Message.error(data.message.mn)
	}else {
		Vm.$Message.error(data.message)
	}
}

export default instanct
